import Vue from "vue";
import VueRouter from "vue-router";
// import Home from "../views/Home.vue";
import Vaccine from "../views/Vaccine.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Vaccine",
    component: Vaccine,
  },
  {
    path: "/about",
    name: "About",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/About.vue"),
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;
